import { type ComponentProps, useRef } from 'react';

import { Container, Flex } from '@change-corgi/design-system-legacy/layout';

import { useActionBar } from './hooks/useActionBar';

export const ActionBar: React.FC<ActionBarProps> = ({ children, ...rest }) => {
	const actionBarRef = useRef<HTMLDivElement>(null);
	const { data } = useActionBar(actionBarRef);
	return (
		<Flex
			data-qa="action-bar"
			ref={actionBarRef}
			data-testid={data.isSticky ? 'action-bar-sticky' : 'action-bar'}
			sx={{
				backgroundColor: 'sunrise.semantic.background.base',
				marginTop: 'sunrise.6',
				borderTop: data.isSticky ? '1px solid' : 'none',
				borderColor: 'sunrise.semantic.stroke.weaker',
				left: 0,
				right: 0,
				bottom: -1,
				zIndex: 1,
				position: data.isSticky ? ['fixed', 'sticky'] : ['fixed', 'initial'],
			}}
			{...rest}
		>
			<Container sx={{ maxWidth: '620px', p: 'sunrise.4' }}>{children}</Container>
		</Flex>
	);
};

type ActionBarProps = ComponentProps<typeof Flex>;
